
import React, { Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { Sky, Loader, Environment, Stats, OrbitControls } from "@react-three/drei"
import { Physics } from '@react-three/cannon'
import Field from './3d/Field';
import Stick from './3d/Stick'
import Plane from './3d/Plane';
import Arm from './3d/Arm';
import OuterRing from './3d/OuterRing';
import InnerRing from './3d/InnerRing';
import Pocket from './3d/Pocket';
import GlassDome from './3d/GlassDome';
import Machine from './3d/Machine';
import Pucks from './3d/Pucks';
import FrontPanel from './3d/FrontPanel';
import StartBtn from './3d/StartBtn';

function App() {

  return (
    <Suspense fallback={null}>
      <>
        <Canvas
          shadows
          dpr={[.5, 1]}
          camera={{ position: [0, 2.7, 2.4], fov: 50, near: 0.05 }}
        >
          <OrbitControls target={[0, 1.6, 0.4]} />
          <Sky sunPosition={[10, 3, 10]} />
          <ambientLight intensity={0.25} />
          <spotLight intensity={1} angle={0.5} penumbra={1} position={[2, 4.5, 4]} castShadow shadow-mapSize={[1024, 1024]} />

          <Environment files="/environment.hdr" background={false} />

          <Physics defaultContactMaterial={{ contactEquationRelaxation: 4, friction: 1e-3 }}>
            <Machine />
            <FrontPanel />
            <Field />
            <InnerRing />
            <OuterRing />
            <Stick />
            <Arm />
            <Pucks />
            <Pocket />
            <StartBtn />
            <GlassDome />
            <Plane />
          </Physics>
        </Canvas >

        <Stats />
        <Loader dataInterpolation={(p) => `Loading ${Math.floor(p)}%`} />
      </>
    </Suspense >
  );
}

export default App;
